/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import Select from 'react-select'
import {ToastContainer} from 'react-toastify'
import {FileUploader} from 'react-drag-drop-files'
import { Tr } from '../../../../_metronic/i18n/Tr'

export function PersonalDetails(props: any) {
  const fileTypes = ['JPEG', 'JPG', 'PNG', 'PDF']
  let t = Tr()

  return (
    <>
      <ToastContainer />
      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_signup_form'
      >
        <div className='text-center mb-11'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{t("Business Information")}</h1>
          {/* end::Title */}
        </div>
        {/* end::Heading */}

        {/* begin::Form group Firstname */}
        <div
          className='dropzone border-success bg-light-success mb-2'
          id='kt_ecommerce_add_reject_reason'
        >
          <div className='dz-message needsclick'>
            {/* <!--begin::Icon--> */}
            <i className='fas fa-info-circle text-success fs-5 mt-1'></i>
            <div className='ms-4'>
              <span className='fs-7 fw-semibold text-gray-600'>
              {t("Please make sure that all information is accurate and correctly entered for us to accept your application. Applications with incorrect or false information will be canceled.")}
              </span>
            </div>
          </div>
        </div>
        <div className='fv-row my-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>
            {t("Property Owner Name")}
          </label>
          {/* <!--begin::Input--> */}
          <input
            type='text'
            name='ownerName'
            id='ownerName'
            className='form-control mb-2'
            placeholder={t("Property Owner Name")}
            value={props.ownerName}
            onChange={(e) => {
              props.setOwnerName(e.target.value)
              props.removeError('ownerName')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].ownerName}</div>
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6 required'>{t("Business Name")}</label>
          {/* <!--begin::Input--> */}
          <input
            type='text'
            name='businessName'
            id='businessName'
            className='form-control mb-2'
            placeholder={t("Business Name")}
            value={props.businessName}
            onChange={(e) => {
              props.setBusinessName(e.target.value)
              props.removeError('businessName')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].businessName}</div>
        </div>
        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t("Country")}</label>
          {/* <!--begin::Input--> */}
          <Select
            name='country'
            id='country'
            placeholder={t('Select Country')}
            isSearchable={true}
            options={props.countryList}
            value={props.countrySelectedOptions}
            onChange={(e: any) => {
              props.setCountrySelectedOptions(e)
              props.removeError('country')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].country}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t("Region")}</label>
          {/* <!--begin::Input--> */}

          <Select
            name='selectRegion'
            id='selectRegion'
            placeholder={t("Select Region")}
            isSearchable={true}
            options={props.regionList}
            value={props.regionSelectedOptions}
            onChange={(e: any) => props.setRegionSelectedOptions(e)}
            styles={{
              container: (provided) => ({...provided, width: '100%'}),
              control: (provided) => ({...provided, minHeight: 43}),
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].regionId}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t("Address Line 1")}</label>
          {/* <!--begin::Input--> */}
          <input
            type='text'
            name='addressLine1'
            id='addressLine1'
            className='form-control mb-2'
            placeholder={t('Address Line 1')}
            value={props.addressLine1}
            onChange={(e) => {
              props.setAddressLine1(e.target.value)
              props.removeError('addressLine1')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].addressLine1}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{t("Address Line 2")} ({t("Optional")})</label>
          {/* <!--begin::Input--> */}
          <input
            type='text'
            name='addressLine2'
            id='addressLine2'
            className='form-control mb-2'
            placeholder={t('Address Line 2')}
            value={props.addressLine2}
            onChange={(e) => {
              props.setAddressLine2(e.target.value)
              props.removeError('addressLine2')
            }}
          />
          {/* <!--end::Input--> */}
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t("Zip Code")}</label>
          {/* <!--begin::Input--> */}
          <input
            type='text'
            name='zipCode'
            id='zipCode'
            className='form-control mb-2'
            placeholder={t('Zip Code')}
            value={props.zipCode}
            onChange={(e) => {
              props.setZipCode(e.target.value)
              props.removeError('zipCode')
            }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{props.error[0].zipCode}</div>
        </div>
        <div className='fv-row mb-8'>
          <div className='mt-5' id='businessRegistration'>
            <FileUploader
              multiple={false}
              handleChange={props.handleBusinessRegistrationChange}
              name='businessRegistration'
              types={fileTypes}
              classes='w-100'
            >
              <div
                className='dropzone border-success bg-light-success dz-clickable'
                id='kt_ecommerce_add_business_certificate'
                onClick={() => props.handleDivClick('businessRegistration')}
              >
                <div className='dz-message needsclick'>
                  {/* <!--begin::Icon--> */}
                  <i className='ki-outline ki-file-up text-success fs-3x'></i>
                  {/* <!--end::Icon--> */}
                  {/* <!--begin::Info--> */}
                  <div className='ms-4'>
                    <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                      {t("Upload Business Registration")}
                    </h3>
                    <span className='fs-7 fw-semibold text-gray-500'>
                      {t("Drag & Drop or choose files from computer")}
                    </span>
                  </div>
                  {/* <!--end::Info--> */}
                </div>
              </div>
            </FileUploader>
            {/* <!--begin::Message--> */}
          </div>
          <div className='text-danger fw-bold'>{props.error[0].businessRegistration}</div>
          <div className='row mt-3'>
            {props.businessRegistration ? (
              <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                {props.businessRegistration &&
                props.businessRegistration.type.startsWith('image/') ? (
                  <div
                    className='shadow-sm rounded-4'
                    style={{maxWidth: 'fit-content', width: '300px', height: '200px'}}
                  >
                    <a href={URL.createObjectURL(props.businessRegistration)} target='_blank'>
                      <img
                        alt='images'
                        className='p-2 rounded-4'
                        src={URL.createObjectURL(props.businessRegistration)}
                        width='100%'
                        style={{width: '300px', height: '200px'}}
                      />
                    </a>
                  </div>
                ) : (
                  <div className='card h-200px shadow-sm rounded-4 w-300px'>
                    <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                      <a
                        href={URL.createObjectURL(props.businessRegistration)}
                        target='_blank'
                        className='text-gray-800 text-hover-primary d-flex flex-column'
                      >
                        <div className='symbol symbol-75px mb-6'>
                          <img src={toAbsoluteUrl('/media/otherSVG/pdf.svg')} alt='pdf' />
                        </div>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                {props.businessRgst ? (
                  <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                    {props.businessRgst && props.businessRgst.endsWith('.pdf') ? (
                      <div className='card h-200px shadow-sm rounded-4 w-300px'>
                        <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                          <a
                            href={props.businessRgst}
                            target='_blank'
                            className='text-gray-800 text-hover-primary d-flex flex-column'
                          >
                            <div className='symbol symbol-75px mb-6'>
                              <img src={toAbsoluteUrl('/media/otherSVG/pdf.svg')} alt='pdf' />
                            </div>
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div
                        className='shadow-sm rounded-4'
                        style={{maxWidth: 'fit-content', width: '300px', height: '200px'}}
                      >
                        <a href={props.businessRgst} target='_blank'>
                          <img
                            alt='images'
                            className='p-2 rounded-4'
                            src={props.businessRgst}
                            width='100%'
                            style={{width: '300px', height: '200px'}}
                          />
                        </a>
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                )}
              </>
            )}
          </div>
        </div>
        {/* begin::Form group */}
        <div className='text-center'>
          <button
            type='button'
            disabled={props.disable}
            className='btn btn-lg btn-primary mb-5 me-3'
            onClick={props.addBusinessDetailsApi}
          >
            <span className='indicator-label'>{t("Submit")}</span>
            {props.loading && (
              <span
                className='spinner-border spinner-border-sm mx-2'
                role='status'
                aria-hidden='true'
              ></span>
            )}
          </button>

          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary mb-5'
            onClick={() => {
              props.onHide()
            }}
          >
            {t("Cancel")}
          </button>
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
